import SavDynamicForm from './default/SavDynamicForm'

export default {
    'sav-dynamic-form': SavDynamicForm
}



// WEBPACK FOOTER //
// ./src/companies/casino/components/conf.js